import React, { useRef, useEffect, useState, useCallback, useMemo } from 'react';
import ReactDOM from 'react-dom';
import MapBox from './MapBox';
import FilterBar from './FilterBar';
import FilterView from './FilterView';
import QueryController from './QueryController';
import FadeModal from './FadeModal';
import ProductView from './property/ProductView';
import useProductQuery from './ProductQuery';
import SimpleBackdrop from './SimpleBackdrop';
import SideNav from './SideNav';
import SideView from './SideView';
import Fab from '@material-ui/core/Fab';
import FilterListIcon from '@material-ui/icons/FilterList';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import LeftFilter from './LeftFilter';
import LayersIcon from '@material-ui/icons/Layers';
import MapLayerDial from './MapLayerDial';
import Button from '@material-ui/core/Button';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import TuneRoundedIcon from '@material-ui/icons/TuneRounded';
import MainFilter from './filters/MainFilter';
const useStyles = makeStyles((theme) => ({
    fab: {
        left: theme.spacing(2),
        top: theme.spacing(2),
        marginTop: "10px",
        marginRight: "10px",
        pointerEvents: "auto",
    },
    fabCont: {
        flexDirection: "column",
        display: "flex",
        justifyContent: "flex-start"
    }
}));

const MapView = ({ }) => {
    const [showFilters, setShowFilters] = useState(false);
    const classes = useStyles();
    const theme = useTheme();
    const [lng, setLng] = useState(-2.0);
    const [lat, setLat] = useState(52.50);
    const [bounds, setBounds] = useState(null);
    const [zoom, setZoom] = useState(6);
    const [data, setData] = useState(null);
    const [filterTerms, setFilterTerms] = useState([]);
    const [open, setOpen] = useState(false);
    const [propViewOpen, setPropViewOpen] = useState(false);
    const [clickedItem, setClicked] = useState(null);
    const [productOpen, setProductOpen] = useState(false);
    const [productLoading, setProductLoading] = useState(false);
    const [product, setProduct] = useProductQuery();
    const [cnt, setCnt] = useState(0);
    const [poly, setPoly] = useState(null);
    const [crimes, setCrimes] = useState(null);
    const [schools, setSchools] = useState(null);
    const [toggleFly, setToggleFly] = useState(null);
    const [prevLocation, setPrevLocation] = useState(null);
    const sideNavRef = useRef();
    const sideViewRef = useRef();
    const [mapStyle, setMapStyle] = useState({ style: "ckouk806n1vxr17lkaic8078y?optimize=true", dark: false });

    const leftFilter = useMemo(() => <LeftFilter filterData={data} filterTerms={filterTerms} setFilterTerms={setFilterTerms} setCnt={setCnt} />, [filterTerms, data]);

    //const memoMainFilter = useMemo(() => <MainFilter
    //    open={showFilters}
    //    setOpen={setShowFilters}
    //    filterData={data}
    //    filterTerms={filterTerms}
    //    setFilterTerms={setFilterTerms}
    //    setCnt={setCnt} />,
    //    [filterTerms, data]);

    useEffect(() => {
        if (clickedItem) {
            setProductOpen(false);
            setProductLoading(true);
            setProduct(clickedItem);
            setPrevLocation({ longitude: lng, latitude: lat, zoom: zoom });
        }
    }, [clickedItem]);

    useEffect(() => {
        if (product) {
            setPoly(product.data.polyJson);
            setSchools(product.data.schools);
            setCrimes(product.data.crime);
            setProductOpen(true);
            setProductLoading(false);
        }
    }, [product]);

    useEffect(() => {
        if (!productOpen) {
            setPoly(null);
            setSchools(null);
            setCrimes(null);
            setClicked(false);
            let flyObj = {
                left: sideNavRef.current && open ? sideNavRef.current.offsetWidth : 0,
                right: sideViewRef.current && productOpen ? sideViewRef.current.offsetWidth : 0,
                loc: prevLocation
            }
            setToggleFly(flyObj);
        }
        else {
            let flyObj = {
                left: sideNavRef.current && open ? sideNavRef.current.offsetWidth : 0,
                right: sideViewRef.current && productOpen ? sideViewRef.current.offsetWidth : 0,
                loc: product.data.location
            }
            console.log(flyObj);
            setToggleFly(flyObj);
        }
    }, [productOpen, sideNavRef, sideViewRef, prevLocation]);

    return (
        <div className='fullHeight' >

            <div className="abs left"  >
                <div className={classes.fabCont}>
                    <span>
                        <Button color="secondary"
                            aria-label="add"
                            variant="contained"
                            startIcon={<ChevronRightIcon />}
                            className={classes.fab}
                            onClick={() => setOpen(true)}>Show List</Button>

                        <Button color="secondary"
                            aria-label="add"
                            variant="contained"
                            className={classes.fab}
                            startIcon={<TuneRoundedIcon />}
                            onClick={() => setShowFilters(true)}>Filters</Button>
                    </span>
                    {/*<Fab color="secondary" aria-label="add" className={classes.fab} onClick={() => setShowFilters(true)} >*/}
                    {/*    <FilterListIcon />*/}
                    {/*</Fab>*/}

                    <MapLayerDial setMapStyle={setMapStyle} className={classes.fab} />
                </div>

                <SideNav open={open} setOpen={setOpen} cnt={cnt} ref={sideNavRef} >
                    {leftFilter}
                </SideNav>
                <SideView open={productOpen} setOpen={setProductOpen} ref={sideViewRef}>
                    <ProductView item={product} setOpen={setProductOpen} />
                </SideView>
                <MainFilter open={showFilters} setOpen={setShowFilters} filterData={data} filterTerms={filterTerms} setFilterTerms={setFilterTerms} />
            </div>

            <MapBox data={data} setData={setData} lng={lng} setLng={setLng} lat={lat} setLat={setLat} zoom={zoom}
                setZoom={setZoom} bounds={bounds} setBounds={setBounds} setClicked={setClicked} poly={poly} toggleFly={toggleFly} schools={schools} crimes={crimes} mapStyle={mapStyle} />

            <QueryController setData={setData} bounds={bounds} filterTerms={filterTerms} />
            <SimpleBackdrop open={productLoading} />
        </div>
    );

}

export default MapView;